module.exports = __webpack_public_path__ + "img/Find_Cannabis_Near_You.bc387458.svg";